import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SelectWithOtherOptionComponent } from './select-with-other-option/select-with-other-option.component';
import { AutocompleteWithFallbackInputComponent } from './components/autocomplete-with-fallback-input/autocomplete-with-fallback-input.component';
import { FormLabelPipe } from './pipes/form-label.pipe';
import { CommaToDotPipe } from './pipes/comma-to-dot.pipe';
import { ManglePipe } from './pipes/mangle.pipe';
import { VariantCardComponent } from './components/variant-card/variant-card.component';
import { ErrorMessagesComponent } from './components/error-messages/error-messages.component';
import { ReactiveLabelDirective } from './directives/reactive-label.directive';
import { CtrlErrorMessageDirective } from '@co-3/ctrl-ui/forms';

const modules = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule];
const components = [SelectWithOtherOptionComponent];

@NgModule({
    imports: [
        modules,
        VariantCardComponent,
        ErrorMessagesComponent,
        CommaToDotPipe,
        ManglePipe,
        FormLabelPipe,
        ReactiveLabelDirective,
        AutocompleteWithFallbackInputComponent,
        CtrlErrorMessageDirective,
        SelectWithOtherOptionComponent,
    ],
    exports: [
        modules,
        components,
        CommaToDotPipe,
        ManglePipe,
        FormLabelPipe,
        VariantCardComponent,
        ErrorMessagesComponent,
        AutocompleteWithFallbackInputComponent,
    ],
})
export class SharedModule {}
